import appConfig from 'configs/app.config';
import { SOUND } from 'configs/app.constants';
import { useNotificationContext } from 'contexts/NotificationContext';
import { messaging } from 'firebaseClient';
import {
  CURRENT_TOKEN_KEY,
  getFirebaseToken,
  saveCurrentFirebaseToken,
} from 'helpers';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegistFirebaseToken } from 'services/auth';

const useFirebase = () => {
  const { changeNotification } = useNotificationContext();
  const firebaseCurrentToken = getFirebaseToken(CURRENT_TOKEN_KEY);

  const { mutate } = useRegistFirebaseToken({
    onSuccess: response => {
      saveCurrentFirebaseToken(response?.data?.registration_token);
    },
  });
  const { serviceWorker } = navigator;
  const location = useLocation();
  useEffect(() => {
    if (serviceWorker) {
      serviceWorker.ready.then(registration => {
        if (Notification.permission === 'granted') {
          messaging
            ?.getToken({
              vapidKey: appConfig.fcmVapidId,
              serviceWorkerRegistration: registration,
            })
            .then(currentToken => {
              if (currentToken !== firebaseCurrentToken) {
                mutate({
                  registrationToken: currentToken,
                });
              }
            })
            .catch(err => {
              console.error('got trouble while mutate firebase token', err);
            });
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then(permission => {
            // If the user accepts, let's create a notification
            if (permission === 'granted') {
              window.location.reload();
            }
          });
        }
      });
    } else {
      if (Notification.permission === 'granted') {
        messaging
          ?.getToken({
            vapidKey: appConfig.fcmVapidId,
          })
          .then(currentToken => {
            if (currentToken !== firebaseCurrentToken) {
              mutate({
                registrationToken: currentToken,
              });
            }
          })
          .catch(err => {
            console.error('got trouble while mutate firebase token', err);
          });
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(permission => {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            window.location.reload();
          }
        });
      }
    }
  }, [location.pathname]);
  messaging?.onMessage(payload => {
    handleNotification(payload);
  });
  const broadcast = new BroadcastChannel('firebase-messaging-channel');

  useEffect(() => {
    // Listen to the response
    if (broadcast) {
      broadcast.onmessage = event => {
        const { payload } = event.data;
        handleNotification(payload);
      };
    }
  }, [broadcast.onmessage]);
  const handleNotification = (payload: any) => {
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
      body: payload.notification.body,
      icon: `${process.env.PUBLIC_URL}/logo192.png`,
      vibrate: [200, 100, 200],
    };
    if (Notification.permission === 'granted') {
      const notification = new Notification(
        notificationTitle,
        notificationOptions,
      );
      notification.onclick = e => {
        e.preventDefault();
        notification.close();
      };
      const notificationData = payload?.data;
      const notificationDataFirebase =
        notificationData && JSON.parse(notificationData?.notification);
      changeNotification({
        ...notificationDataFirebase,
      });
      const audio = new Audio(SOUND.notification);
      audio.play();
    }
  };

  return true;
};
export default useFirebase;
